module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.minimized) ? _c('div', {
    staticClass: "spacer"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top left"
  }, [_c('div', [(_vm.minimized) ? _c('span', {
    staticClass: "ui grey icon corner button",
    on: {
      "click": function($event) {
        _vm.minimized = false
      }
    }
  }, [_c('i', {
    staticClass: "ui info circle icon"
  }), _vm._v("\n                Explore Topics\n                "), _c('i', {
    staticClass: "ui chevron right icon"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.minimized) ? _c('div', {
    staticClass: "ui grey inverted segment"
  }, [_c('i', {
    staticClass: "ui info circle icon"
  }), _vm._v("\n            Explore Topics\n            "), _c('div', {
    staticClass: "ui simple dropdown right labeled search icon button"
  }, [(!_vm.selectedQuestion) ? _c('span', {
    staticClass: "subdued"
  }, [_vm._v("Find questions you are interested in and click Go for the answers")]) : _vm._e(), _vm._v(" "), (_vm.selectedQuestion) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.selectedQuestion.q) + "\n                    "), _c('span', {
    staticClass: "subdued"
  }, [_vm._v("metric: " + _vm._s(_vm.selectedQuestion.m))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('h4', [_vm._v("Contributing")]), _vm._v(" "), _vm._l((_vm.contributingQuestions), function(q) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectQuestion(q)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(q.q) + " "), _c('span', {
      staticClass: "subdued"
    }, [_vm._v("metric: " + _vm._s(q.m))])])
  }), _vm._v(" "), _c('h4', [_vm._v("Reading")]), _vm._v(" "), _vm._l((_vm.readingQuestions), function(q) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectQuestion(q)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(q.q) + " "), _c('span', {
      staticClass: "subdued"
    }, [_vm._v("metric: " + _vm._s(q.m))])])
  }), _vm._v(" "), _c('h4', [_vm._v("Content")]), _vm._v(" "), _vm._l((_vm.contentQuestions), function(q) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectQuestion(q)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(q.q) + " "), _c('span', {
      staticClass: "subdued"
    }, [_vm._v("metric: " + _vm._s(q.m))])])
  }), _vm._v(" "), _c('h4', [_vm._v("More")]), _vm._v(" "), _vm._l((_vm.moreQuestions), function(q) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectQuestion(q)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(q.q) + " "), _c('span', {
      staticClass: "subdued"
    }, [_vm._v("metric: " + _vm._s(q.m))])])
  })], 2), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui blue button",
    on: {
      "click": _vm.go
    }
  }, [_vm._v("Go")]), _vm._v(" "), _c('span', {
    staticClass: "right floated"
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.minimized = true
      }
    }
  }, [_c('i', {
    staticClass: "ui left chevron icon"
  })])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2c9ba179"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopicExplorer.vue
// module id = 385
// module chunks = 1